export const zh = {
  translation: {
    "Belimo Energy Valve": "搏力谋能量阀",
    Yes: "是",
    No: "否",
    "You cannot go back from this position":
      "您不能从这个位置返回",
    Chapters: "章节",
    Start: "开启",
    "Connecting to the Energy Valve": "连接至能量阀",
    "Control Source": "控制源",
    "Do you know the design flow rate?":
      "您知道设计的流速吗？",
    "Flow Control": "流量控制",
    "Is the building running off fixed or varying flow temperatures?":
      "建筑物内的流动温度是固定的还是变化的？",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "变化的流动温度（ΔT管理器缩放比例）",

    "Fixed flow temperatures (Delta T Manager)":
      "固定的流动温度 (ΔT管理器)",
    "I am not sure": "我不确定",
    "Delta T Manager": "ΔT 管理器",
    Scaling: "比例缩放",
    "Do you know the power output?": "您知道功率输出值吗?",
    "Yes (Power Control)": "是 (功率控制)",
    "No (Position Control)": "否 (位置控制)",
    "Power Control": "功率控制",
    "Position Control": "位置控制",
    "Onboard Data Analysis": "配备数据分析",
    "Did you get a clear result from the Energy Valve?":
      "您从能量阀获得明确的结果了吗？",
    "How do you want to setup your Energy Valve?":
      "您想如何设置您的能量阀？",
    "Would you like to connect to the cloud?":
      "您想连接到云端吗？",
    "Cloud Connectivity": "云端连接",
    "Onboard Diagnostics / Download Data":
      "配备诊断 / 下载数据",
    "Download Data": "下载数据",
    "Send optimization request": "发出优化申请",
    End: "结束",

    Subtitles: "字幕",
    Repeat: "重复",
    Continue: "继续",
  },
};
